import { entitiesData, selectedAccountData } from '@/composables/globalData/useEntitiesData'
import { isTranslationHistoryTrackEnabled } from '@/i18n'

const LOGIN_STATUS_NAMES_COLUMNS = [ 'breaks', 'duration' ]

export default {
    computed: {
        defaultAccountBreakList () {
            return entitiesData.value.DefaultAccountBreak
        },
        currentAccountBreakList () {
            return selectedAccountData.value.AccountBreaks
        }
    },
    methods: {
        getColumnTagsByProp (columnProp) {
            const translateOfHeaderTitleInitials = `widget.table.header.title.initials.${columnProp}`
            const translateOfHeaderTitleFull = `widget.table.header.title.full.${columnProp}`

            return {
                translateOfHeaderTitleInitials,
                translateOfHeaderTitleFull
            }
        },
        getColumnTags (column) {
            const columnProp = column.prop

            return this.getColumnTagsByProp(columnProp)
        },
        makeTableHeaderTranslations (column) {
            const { translateOfHeaderTitleInitials, translateOfHeaderTitleFull } = this.getColumnTags(column)

            const translation = this.$te(translateOfHeaderTitleInitials)
                ? this.$t(translateOfHeaderTitleInitials)
                : this.$te(translateOfHeaderTitleFull)
                    ? this.$t(translateOfHeaderTitleFull)
                    : column.label

            return this.replaceDefaultLoginStatusNameWithAccountBreakName(translation)
        },
        makeTableHeaderTranslationsByProp (prop) {
            const { translateOfHeaderTitleInitials, translateOfHeaderTitleFull } = this.getColumnTagsByProp(prop)

            const translation = this.$te(translateOfHeaderTitleInitials)
                ? this.$t(translateOfHeaderTitleInitials)
                : this.$te(translateOfHeaderTitleFull)
                    ? this.$t(translateOfHeaderTitleFull)
                    : prop

            return this.replaceDefaultLoginStatusNameWithAccountBreakName(translation)
        },
        makeTableHeaderTooltipTranslations (column) {
            const { translateOfHeaderTitleFull, translateOfHeaderTitleInitials } = this.getColumnTags(column)

            const translation = this.$te(translateOfHeaderTitleFull)
                ? this.$t(translateOfHeaderTitleFull)
                : column.label

            const shouldShowTranslationTags = this.$isDev || isTranslationHistoryTrackEnabled()

            if (shouldShowTranslationTags) {
                return translation + '\n' + `('${translateOfHeaderTitleFull}'/'${translateOfHeaderTitleInitials}')`
            } else {
                return this.replaceDefaultLoginStatusNameWithAccountBreakName(translation)
            }
        },
        getDefaultAccountBreak (columnName) {
            const columnNameTrimmed = columnName.trim()

            return this.defaultAccountBreakList.find(el => {
                const regex = new RegExp(el.Name.trim(), 'i')

                return regex.test(columnNameTrimmed)
            })
        },
        getCurrentAccountBreakById (id) {
            return this.currentAccountBreakList.find(el => el.StatusID.toString() === id.toString())
        },
        isLoginStatusColumnByLoginStatusNamesColumns (columnName) {
            return LOGIN_STATUS_NAMES_COLUMNS.find(el => columnName.trim().toLowerCase().includes(el)) !== undefined
        },
        replaceDefaultLoginStatusNameWithAccountBreakName (columnName) {
            if (typeof columnName !== 'string') {
                return columnName
            }

            const defaultAccountBreak = this.getDefaultAccountBreak(columnName)

            if (defaultAccountBreak === undefined || !this.isLoginStatusColumnByLoginStatusNamesColumns(columnName)) {
                return columnName
            }

            const currentAccountBreak = this.getCurrentAccountBreakById(defaultAccountBreak.StatusID)

            if (!currentAccountBreak) {
                return columnName
            }

            const regex = new RegExp(defaultAccountBreak.Name.trim(), 'i')

            return columnName.replace(regex, currentAccountBreak.Name.trim())
        }
    }
}
